jQuery(function(){
    function close_section($section, class_name) {

        $section.removeClass(class_name + '__link-title--active');


        $section.closest('.'+ class_name + '__section--open').find('.' + class_name + '__content-container--visible').removeClass(class_name + '__content-container--visible');
		$section.closest('.' + class_name + '__section--open').removeClass(class_name + '__section--open');
    }

    jQuery('body').on('click', '.account-accordion__link-title', function(e){
        var $this = jQuery(this);

        if($this.hasClass('account-accordion__link-title--active')) {
            close_section($this, 'account-accordion');

        } else {
            $this.addClass('account-accordion__link-title--active');
            $this.closest('.account-accordion__section').addClass('account-accordion__section--open');
            $this.closest('.account-accordion__section').find('.account-accordion__content-container').addClass('account-accordion__content-container--visible');
        }

        e.preventDefault();

        return false;
    });

    jQuery('.accordion__link-title').attr("aria-expanded", "false");
    jQuery('.accordion__link-title--active').attr("aria-expanded", "true");

    jQuery('body').on('click', '.accordion__link-title', function(e){
        var $this = jQuery(this);

        if($this.hasClass('accordion__link-title--active')) {
            close_section($this, 'accordion');
            //$this.next('.accordion__section').css({'opacity': '0'});
            $this.attr("aria-expanded", "false");

        } else {
            $this.addClass('accordion__link-title--active');
            //$this.closest('.accordion__section').css({'opacity': '100'});
            $this.closest('.accordion__section').addClass('accordion__section--open');
            $this.closest('.accordion__section').find('.accordion__content-container').addClass('accordion__content-container--visible');
            $this.attr("aria-expanded", "true");
        }

        e.preventDefault();

		return false;
    });

    jQuery('body').on('click', '.video-accordion__link-title', function(e){
        var $this = jQuery(this);

        if($this.hasClass('video-accordion__link-title--active')) {
            close_section($this, 'video-accordion');

        } else {
            $this.addClass('video-accordion__link-title--active');
            $this.closest('.video-accordion__section').addClass('video-accordion__section--open');
            $this.closest('.video-accordion__section').find('.video-accordion__content-container').addClass('video-accordion__content-container--visible');
        }

        e.preventDefault();

		return false;
    });

});